export default "__VITE_ASSET__00818188__"